import React, { useState, useEffect } from 'react';
import './FeaturesSection.css';
import { DownloadOutlined, CreditCardOutlined, ScanOutlined, CustomerServiceOutlined, SafetyOutlined, RocketOutlined, LeftOutlined, RightOutlined } from '@ant-design/icons';

const features = [
  { icon: <DownloadOutlined />, title: 'Instant Ticket Delivery', desc: 'Receive your tickets immediately after purchase — no waiting required.' },
  { icon: <CreditCardOutlined />, title: 'Secure Checkout', desc: 'Pay safely using trusted payment methods including Apple Pay and major credit cards.' },
  { icon: <ScanOutlined />, title: 'Go Paperless', desc: 'Access your tickets digitally and breeze through entry with easy QR scanning.' },
  { icon: <CustomerServiceOutlined />, title: '24/7 Support', desc: "We're here for you anytime — just reach out and we'll take care of you." },
  { icon: <SafetyOutlined />, title: 'Trusted Platform', desc: 'Your security is our priority. Buy tickets with complete confidence.' },
  { icon: <RocketOutlined />, title: 'Fast Booking', desc: 'Book your tickets in seconds with our streamlined and intuitive platform.' },
];

function FeaturesSection() {
  const [current, setCurrent] = useState(0);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    if (!isMobile) return;
    const timer = setInterval(() => {
      setCurrent((prev) => (prev + 1) % features.length);
    }, 3500);
    return () => clearInterval(timer);
  }, [isMobile]);

  const prev = () => setCurrent((c) => (c - 1 + features.length) % features.length);
  const next = () => setCurrent((c) => (c + 1) % features.length);

  return (
    <div className="features-section">
      <h2 className="features-heading">Everything You Need</h2>
      <p className="features-subheading">Built for event-goers who want fast, secure, and hassle-free ticketing.</p>

      {isMobile ? (
        <div className="features-slider">
          <div className="feature-card">
            <div className="feature-icon-wrap">{features[current].icon}</div>
            <h3>{features[current].title}</h3>
            <p>{features[current].desc}</p>
          </div>
          <div className="features-controls">
            <button className="features-arrow" onClick={prev}><LeftOutlined /></button>
            <div className="features-dots">
              {features.map((_, i) => (
                <span key={i} className={`features-dot ${i === current ? 'active' : ''}`} onClick={() => setCurrent(i)} />
              ))}
            </div>
            <button className="features-arrow" onClick={next}><RightOutlined /></button>
          </div>
        </div>
      ) : (
        <div className="features-grid">
          {features.map((f, i) => (
            <div key={i} className="feature-card" data-aos="fade-up" data-aos-delay={i * 60}>
              <div className="feature-icon-wrap">{f.icon}</div>
              <h3>{f.title}</h3>
              <p>{f.desc}</p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default FeaturesSection;